import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import _ from 'lodash';
import { FontAwesome } from '../FontAwesome';
import './style.scss';

export class TextField extends React.PureComponent {
  static propTypes = {
    label: PropTypes.string,
    className: PropTypes.string,
    value: PropTypes.string,
    min: PropTypes.string,
    max: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onValueChange: PropTypes.func,
    icon: PropTypes.string,
    description: PropTypes.node,
    error: PropTypes.string,
    required: PropTypes.bool,
    focusOnMount: PropTypes.bool,
    button: PropTypes.shape({
      icon: PropTypes.string,
      label: PropTypes.string,
      hideLabel: PropTypes.bool,
      onClick: PropTypes.func,
    }),
  };

  static defaultProps = {
    label: null,
    className: null,
    value: '',
    min: null,
    max: null,
    onChange: () => {},
    onBlur: () => {},
    onValueChange: () => {},
    icon: null,
    description: null,
    error: null,
    required: false,
    focusOnMount: false,
    button: null,
  };

  constructor(props) {
    super(props);
    this.inputId = _.uniqueId();
    this.inputRef = React.createRef();
  }

  componentDidMount() {
    const { focusOnMount } = this.props;

    if (focusOnMount) {
      this.inputRef.current.focus();
    }
  }

  onChange = (event) => {
    const { onChange, onValueChange } = this.props;

    if (onChange) {
      onChange(event);
    }

    if (onValueChange) {
      onValueChange(event.target.value);
    }
  };

  onBlur = (event) => {
    const { onBlur } = this.props;

    onBlur(event);
  };

  renderButton = () => {
    const {
      button: { icon, label, hideLabel, onClick },
    } = this.props;
    return (
      <button type="button" onClick={onClick} className="ol-text-field-button">
        {icon && (
          <FontAwesome name={icon} className="ol-text-field-button-icon" />
        )}
        <span
          className={classNames('ol-text-field-button-label', {
            hidden: hideLabel,
          })}
        >
          {label}
        </span>
      </button>
    );
  };

  render() {
    const {
      onValueChange, // so onValueChange won't be passed to input
      className,
      icon,
      label,
      description,
      error,
      value,
      required,
      focusOnMount,
      button,
      ...propsForInput
    } = this.props;

    return (
      <ol-text-field class={className}>
        {label && (
          <label className="ol-text-field-label" htmlFor={this.inputId}>
            {label}
            {required && (
              <span className="ol-text-field-required"> (required)</span>
            )}
            {error && <span className="ol-text-field-error"> {error}</span>}
          </label>
        )}
        {description && (
          <span className="ol-text-field-description">{description}</span>
        )}
        <span className="ol-text-field-input-wrapper">
          {icon && (
            <div className="ol-text-field-icon-wrapper">
              <FontAwesome name={icon} className="ol-text-field-icon" />
            </div>
          )}
          <input
            {...propsForInput}
            required={required}
            className="ol-text-field-text"
            onChange={this.onChange}
            onBlur={this.onBlur}
            id={this.inputId}
            value={value || ''}
            ref={this.inputRef}
          />
          {button && this.renderButton()}
        </span>
      </ol-text-field>
    );
  }
}
